import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UtcToLocalPipe } from '@myapp/modules/fwcore/pipes';
import { LoggingService } from '@myapp/modules/fwcore/services';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import {
     ExcelModule, GridDataResult, GridModule, PageChangeEvent, RowClassArgs
} from '@progress/kendo-angular-grid';
import { TextBoxModule } from '@progress/kendo-angular-inputs';
import { process } from "@progress/kendo-data-query";

@Component({
  selector: 'app-page-log-interactions',
  standalone: true,
  imports: [GridModule, TextBoxModule, ExcelModule,   DropDownListModule, FormsModule, UtcToLocalPipe],
  templateUrl: './page-log-interactions.component.html',
  styleUrls: ['./page-log-interactions.component.scss']
})
export class PageLogInteractionsComponent {
  public gridData: GridDataResult = { data: [], total: 0 };

  private data: any[] = [];
  private filteredData: any[] = [];

  public pageSize = 10;
  public skip = 0;

  public sizes = [10, 20, 50];

  constructor(private loggingService: LoggingService) {
    this.allData = this.allData.bind(this);
  }

  public ngOnInit(): void {
    this.retrieveData();
  }

  public onFilter(target: EventTarget | null): void {
    if (target != null && target instanceof HTMLInputElement) {
      const inputValue: string = target.value;
      this.filteredData = process(this.data, {
        filter: {
          logic: "or",
          filters: [
            {
              field: "url",
              operator: "contains",
              value: inputValue,
            },
            {
              field: "tstamp",
              operator: "contains",
              value: inputValue,
            }

          ],
        },
      }).data;

      this.skip = 0;
      this.loadItems();
    }
  }

  retrieveData(): void {
    this.loggingService.getPageLogs()
      .subscribe(
        data => {
          this.data = data;
          this.filteredData = this.data;
          this.loadItems();
        });
  }

  refreshData(): void {
    this.retrieveData();
  }


  public pageChange({ skip, take }: PageChangeEvent): void {
    this.skip = skip;
    this.pageSize = take;
    this.loadItems();
  }

  private loadItems(): void {
    this.gridData = {
      data: this.filteredData.slice(this.skip, this.skip + this.pageSize),
      total: this.filteredData.length,
    };
  }

  // For export all data to grid
  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: process(this.data, {}).data
    };

    return result;
  }

  // Use an arrow function to capture the 'this' execution context of the class.
  public rowCallback = (context: RowClassArgs) => {
    return 'customGridRow';
  };

  public pageSizeChange(value: any): void {
    this.skip = 0;
    this.loadItems();
  }

  public startnum() {
    return this.skip + 1;
  }

  public endnum() {
    return Math.min(this.skip + this.pageSize, this.gridData.total);
  }
}

